import { MyBets } from "sb-resp-ui";
export var ui = MyBets.Default;
//# sourceMappingURL=index.js.map